// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-image.contain {
  align-self: center;
  justify-self: center;
  display: block;
  width: 100%;
  height: auto;
}

/*# sourceMappingURL=Image.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Image/Image.scss","webpack://./../azure-devops-ui/bin/Components/Image/Image.css"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,oBAAA;EAEA,cAAA;EACA,WAAA;EACA,YAAA;ACFR;;AAEA,oCAAoC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
